import axiosInstance from '../config/axios.js';

const DB = '/dashboard';

// Keep first paint thin under multi-user load (was 3).
const DASHBOARD_LANES = 2;
let dashboardLanesInUse = 0;
const dashboardLaneWaiters = [];

function withDashboardLane(work) {
  return new Promise((resolve, reject) => {
    const start = () => {
      dashboardLanesInUse += 1;
      Promise.resolve()
        .then(work)
        .then(resolve, reject)
        .finally(() => {
          dashboardLanesInUse -= 1;
          const next = dashboardLaneWaiters.shift();
          if (next) next();
        });
    };
    if (dashboardLanesInUse < DASHBOARD_LANES) start();
    else dashboardLaneWaiters.push(start);
  });
}

function dashboardGet(url, config) {
  return withDashboardLane(async () => {
    const response = await axiosInstance.get(url, config);
    return response.data;
  });
}

const dashboardService = {
  getUsers: () => dashboardGet(`${DB}/users`),
  getVehicles: () => dashboardGet(`${DB}/vehicles`),
  getShipments: (params = {}) => dashboardGet(`${DB}/shipments`, { params }),
  getPayments: (params = {}) => dashboardGet(`${DB}/payments`, { params }),
  getAttendance: (params = {}) => dashboardGet(`${DB}/attendance`, { params }),
  getCommissions: (params = {}) => dashboardGet(`${DB}/commissions`, { params }),
  getOnContracts: (params = {}) => dashboardGet(`${DB}/on-contracts`, { params }),
  getTripContracts: (params = {}) => dashboardGet(`${DB}/trip-contracts`, { params }),
  getSalaries: (params = {}) => dashboardGet(`${DB}/salaries`, { params }),
  getMlAgentDues: (params = {}) => dashboardGet(`${DB}/ml-agent-dues`, {
    params: { include_closed: true, ...params },
  }),
  getCargoOverview: (params = {}) => dashboardGet(`${DB}/cargo-overview`, { params }),
  getCargoDrilldown: (params = {}) => dashboardGet(`${DB}/cargo-overview/drilldown`, { params }),
  getBookingSummary: (params = {}) => dashboardGet(`${DB}/booking-summary`, { params }),
  getBranchAgents: () => dashboardGet(`${DB}/branch-agents`),
  searchShipments: (q, params = {}) => dashboardGet(`${DB}/shipment-search`, {
    params: { q, ...params },
  }),
  getMasterDashboard: (params = {}) => dashboardGet(`${DB}/master`, { params }),
  getAllCompanies: () => dashboardGet('/company'),
};

export default dashboardService;
